import React from 'react'

const Preloader = () => {
    return (
        <div style={{width: '50%', marginTop: 0, marginLeft: 'auto', marginRight: 'auto'}} className="progress grey lighten-2">
            <div className="indeterminate black lighten-4"></div>
        </div>
    )
}

export default Preloader